export function safePathFromCallback(raw: string | null | undefined): string | null {
  if (!raw) return null;

  try {
    // decode once so "%2Fchat" becomes "/chat"
    const s = decodeURIComponent(raw);

    // Only allow absolute **relative** paths like "/chat?x=1"
    // Disallow protocol-relative ("//evil.com"), absolute URLs, and backslashes
    if (!s.startsWith('/') || s.startsWith('//') || s.includes('\\')) return null;

    // Basic sanitation: reject control chars and CR/LF
    if (/[\r\n]/.test(s)) return null;

    // Optionally cap length to avoid abuse
    if (s.length > 2048) return null;

    return s;
  } catch {
    return null;
  }
} 